/* import __COLOCATED_TEMPLATE__ from './message-center-textarea.hbs'; */
import Component from '@glimmer/component';
import { tracked } from '@glimmer/tracking';
import { action } from '@ember/object';
import MessageComposerResizeModifier from 'sh-www/modifiers/message-composer-autosize';
import NoopModifier from 'sh-www/modifiers/noop';

class MessageCenterTextarea extends Component {
  @tracked hasFocus = false;

  get autosizer() {
    return (this.args.enableAutosizer && this.hasFocus) ?
      MessageComposerResizeModifier :
      NoopModifier;
  }

  @action
  onFocus() {
    this.hasFocus = true;
    this.args.onfocus?.();
  }

  @action
  onBlur() {
    this.hasFocus = false;
    this.args.onblur?.();
  }

  @action
  onInput({ target }) {
    this.args.oninput?.(target.value);
  }
}

export default MessageCenterTextarea;
